// Slick Slider
$(document).ready(function(){
  
	// Slider (Ads)
	$('.slider-ads-single-images').each(function () {
  	var slider = $(this);
  	slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
  		arrows: true,
  		infinite: false,
      adaptiveHeight: false,
			speed: 700,
			fade: true,
  	});
	}); 
	$('.slider-ads-images').each(function () {
  	var slider = $(this);
  	slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
  		arrows: true,
  		infinite: false,
      adaptiveHeight: false,
  		speed: 700,
      asNavFor: slider.parent().find('.slider-ads-text'),
  	});
	});  
	$('.slider-ads-text').each(function () {
  	var slider = $(this);
  	slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
  		arrows: false,
  		infinite: false,
      //adaptiveHeight: true,
  		speed: 700,
      asNavFor: slider.parent().find('.slider-ads-images'),
      fade: true,
  	});
	});  
  
	// Slider (Home)
	$('.slider-home').each(function () {
		var slider = $(this);
		slider.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			infinite: true,
			autoplay: true, 
			autoplaySpeed: 6500,
			pauseOnHover: false,
			speed: 1600,
			fade: true
		});
	}); 

	// Slider (Fullscreen)
	$('.slider-fullscreen').each(function () {
		var slider = $(this);
		slider.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			infinite: true,
			autoplay: true, 
			autoplaySpeed: 6500,
			pauseOnHover: false,
			speed: 1600,
			fade: true
		});
	}); 
  
      
});


// WEBPACK FOOTER //
// ./js/parts/slick.js